import type { FC } from "react"

import { resolveLucideIcon } from "./lucide-icon"

// Nucleo's color-2 layer at half opacity, matching the portal's /api/icons
// duotone. Kept apart from article-cover-art so the portal skips the icon set.
export const ArticleDuotoneIcon: FC<{ icon: string | null | undefined }> = ({
	icon,
}) => {
	const Icon = resolveLucideIcon(icon, "outline")
	return (
		<Icon strokeWidth={1.5} className="[&_[data-color=color-2]]:opacity-50" />
	)
}
